import { render, staticRenderFns } from "./TopShareBarWithBack.vue?vue&type=template&id=5deaa23d&scoped=true&"
import script from "./TopShareBarWithBack.vue?vue&type=script&lang=js&"
export * from "./TopShareBarWithBack.vue?vue&type=script&lang=js&"
import style0 from "./TopShareBarWithBack.vue?vue&type=style&index=0&id=5deaa23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deaa23d",
  null
  
)

export default component.exports